import paymentApiClient from '../api/payment';
import useKlydoQuery from './useKlydoQuery';
import useAppContext from './useAppContext';

const FIVE_MINUTES = 1000 * 60 * 5;

const usePaymentStatusQuery = (enabled: boolean) => {
  const { authUser } = useAppContext();
  return useKlydoQuery({
    queryKey: ['paymentStatus', authUser?.uid],
    queryFn: () => paymentApiClient.getPaymentStatus(),
    enabled: enabled && !!authUser?.uid,
    staleTime: FIVE_MINUTES,
  });
};

export default usePaymentStatusQuery;
